var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rn-back-top",class:[_vm.visible ? 'd-inline' : 'd-none']},[_c('img',{attrs:{"src":require("@/assets/images/icons/top.png"),"alt":""},on:{"click":_vm.scrollToTop}})])
}
var staticRenderFns = []

export { render, staticRenderFns }